import noop from 'lodash/noop'
import usePricingRoutes from 'app/SkyNetRoutes/hooks/usePricingRoutes'
import Button from 'app/shared-components/Button'
import getFields from 'app/Apps/Pricing/LaneGroups/LaneFees/LaneFeesTable/LaneFeesForm.fields'
import LaneGroupContextWrapper from 'app/Apps/Pricing/LaneGroups/LaneGroupContextWrapper'
import {
    LaneFeesActionButtons, LaneFeesFormContext, LaneFeesUpdate,
} from 'app/shared-components/LaneFees'
import LaneGroupInformationForm from 'app/Apps/Pricing/LaneFees/LaneGroupInformationForm'
import ContractBasisInformationForm from 'app/Apps/Pricing/LaneFees/ContractBasisInformationForm'
import useGetLaneFee from 'app/Apps/Pricing/LaneGroups/LaneFees/hooks/useGetLaneFee'
import StatusHandler from 'app/shared-components/StatusHandler'
import useStyles from './LaneFeesFormUpdate.styles'

const fields = {
    getFields,
}

export default function LaneFeesFormUpdate({
    id,
    disabled,
}: Readonly<{ id: number, disabled: boolean }>) {
    const {
        LaneFees: LaneFeesRoutes,
    } = usePricingRoutes()
    const {
        classes,
    } = useStyles()
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
    } = useGetLaneFee(id)

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isError={isError}
            isFetching={isFetching}
            error={error}
        >
            <div className={classes.container}>
                <ContractBasisInformationForm
                    update={noop}
                    id={data?.laneGroup?.contractBasisId}
                    disabled
                />
                <LaneGroupInformationForm
                    update={noop}
                    id={data?.laneGroupId}
                    disabled
                    contractId={data?.laneGroup?.contractBasisId}
                />
                <LaneGroupContextWrapper id={data?.laneGroupId}>
                    <LaneFeesFormContext.Provider value={fields}>
                        <LaneFeesUpdate
                            id={id}
                            refetch={noop}
                            disabled={disabled}
                            navigateOnValidityChange={noop}
                            customHandlers={{
                                [LaneFeesActionButtons.Copy]: <Button
                                    label="Copy"
                                    key={LaneFeesActionButtons.Copy}
                                    name={LaneFeesActionButtons.Copy}
                                    onClick={() => {
                                        LaneFeesRoutes.Copy.navigate({
                                            params: {
                                                key: id,
                                                copy: 'copy',
                                            },
                                            options: {
                                                state: {
                                                    laneGroupId: data?.laneGroupId,
                                                    contractBasisId:
                                                    data?.laneGroup?.contractBasisId,
                                                    originId: id,
                                                },
                                            },
                                        })
                                    }}
                                />,
                            }}
                        />
                    </LaneFeesFormContext.Provider>
                </LaneGroupContextWrapper>
            </div>
        </StatusHandler>
    )
}
